$(document).ready(function () {

  var current_url = window.location.href;
  var split_url = current_url.split('form_type=');
  if(split_url[1] == 'customer#ContactFooter'){
    $('.newsletter-already_subscribe_email').html('Email Already Registered!')
  }else{
    $('.newsletter-already_subscribe_email').hide();
  }
  
  $(document).on("click",".announcement-bar-close",function() {
      $(".announcement-bar-sections-div").hide();
      $(this).hide();
  });

//   $(".home-tabs-bg-sliders-mv .tab-product-list").on("init reInit afterChange", function () {
//   const $slider = $(this);
//   const $currentSlide = $slider.find(".slick-slide.slick-active").first();

//   if ($currentSlide.length) {
//     $slider.find(".slick-list").css(
//       "height",
//       $currentSlide.outerHeight() + "px"
//     );
//   }
// });
  $(".home-tabs-bg-sliders-mv .tab-product-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1.3,
    slidesToScroll: 1,
    adaptiveHeight: false,
    initialSlide: 0,
    centerMode: false
  });
    
  $(".single-slider .slide-list").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  });


  $(".lifetime_warranty .bag-groups-wrapper").slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

  
 $('.product-slider .product-list').slick({
    dots: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

 

 $('.customer-slider .customer_list').slick({
    dots: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  



  

// setTimeout(function() {
//   $(".topHeaderTabs ul li").eq(0).click(); 
// }, 3000);

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
  $(".tab-container .tab_content").hide();
  // $(".tab-container .tab_content:first").show();
  $('.tab-container').each(function(k,v){
    $(v).find('.tab_content:first').show();
  });

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
  $('.collection-tab-slider-list').slick('refresh');
  $('.collection-product-slider .collection-product-list').slick('refresh');
  
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
  $('.collection-tab-slider-list').slick('refresh');
  $('.collection-product-slider .collection-product-list').slick('refresh');
  
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");
$('ul.tabs li').first().addClass("tab_first");



  
});

let scrollDiv = document.querySelector("#tab-review")
document.querySelector(".js-review-star") ? document.querySelector(".js-review-star").addEventListener("click",function(e){
  e.preventDefault();
  scrollDiv.style.display = "block";
  document.querySelector("#tab-description").style.display = "none";
  window.scroll({ top: scrollDiv.offsetTop, behavior: "smooth", });
  document.querySelector(".tabs").querySelectorAll("li").forEach((li)=>{
    li.querySelector("a").classList.contains("active") === true ? li.querySelector("a").classList.remove("active") : li.classList.contains("tab_last") === true ? li.querySelector("a").classList.add("active") : '';
  })
}) : '';

document.querySelector(".short_description .button") ? document.querySelector(".short_description .button").addEventListener("click",function(e){
  e.preventDefault();
let scrollDiv = document.querySelector("#tab-description");
  scrollDiv.style.display = "block";
  document.querySelector("#tab-review").style.display = "none";
  document.querySelector("#tab-description").style.display = "block";
  window.scroll({ top: scrollDiv.offsetTop, behavior: "smooth", });
  document.querySelector(".tabs").querySelectorAll("li").forEach((li)=>{
    li.querySelector("a").classList.contains("active") === true ? li.querySelector("a").classList.remove("active") : li.classList.contains("tab_first") === true ? li.querySelector("a").classList.add("active") : '';
  })
}) : '';

$('#tab-description p').each(function() {
  const $this = $(this);
  // console.log($this.html().replace(/\s|&nbsp;/g, '').length);
  if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
   $this.remove();
});

$("span.short_desc").each(function() {
  // Get the current text of the element
  var text = $(this).text();
  
  // Remove the first blank space
  var updatedText = text.replace(/^\s+/, ''); // Removes leading whitespace
  
  // Update the text of the element
  $(this).text(updatedText);
});



// Footer Accordion JS //


document.addEventListener('DOMContentLoaded', function () {
  const mobileQuery = window.matchMedia('(max-width: 640px)');

  document.querySelectorAll('.footer-block').forEach(function (block, index) {
    const heading = block.querySelector('.footer-block__heading');
    const content = block.querySelector('.footer-block__details-content');

    if (!heading || !content) return;

    // Prevent duplicate initialization
    if (heading.dataset.accordionInitialized === 'true') return;
    heading.dataset.accordionInitialized = 'true';

    // Make heading keyboard accessible
    heading.style.cursor = 'pointer';
    heading.setAttribute('role', 'button');
    heading.setAttribute('tabindex', '0');

    function updateAccordion(isMobile, isInitial = false) {
      if (!isMobile) {
        heading.classList.remove('is-open');
        content.classList.remove('is-open');
        content.style.display = '';
        heading.setAttribute('aria-expanded', 'true');
        return;
      }

      // First menu open by default; others closed
      const shouldOpen = isInitial && index === 0;

      heading.classList.toggle('is-open', shouldOpen);
      content.classList.toggle('is-open', shouldOpen);
      content.style.display = shouldOpen ? 'block' : 'none';
      heading.setAttribute('aria-expanded', String(shouldOpen));
    }

    updateAccordion(mobileQuery.matches, true);

    function toggleAccordion() {
      if (!mobileQuery.matches) return;

      const isOpen = content.classList.contains('is-open');

      heading.classList.toggle('is-open', !isOpen);
      content.classList.toggle('is-open', !isOpen);
      content.style.display = isOpen ? 'none' : 'block';
      heading.setAttribute('aria-expanded', String(!isOpen));
    }

    heading.addEventListener('click', toggleAccordion);

    heading.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion();
      }
    });

    mobileQuery.addEventListener('change', function (event) {
      updateAccordion(event.matches, true);
    });
  });
});


